module.exports = __webpack_public_path__ + "static/media/1.3c86d22e.png";